<template>
  <div v-if="visible" class="intervention">
    <div class="example card text-center mb-3">
      <div class="card-body">
        {{ $t('result.context.context-example') }}
        <b>{{ query.uncached.example }}</b>
        {{ $t('result.context.previous-list') }}
      </div>
    </div>
    <a class="btn btn-primary btn-sm my-3" v-if="first > 0" @click.prevent="before += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
    <ul class="list-group">
      <li v-for="text in visibleTexts"
          :key="text.text.id"
          class="context-text list-group-item"
          :class="{ 'bg-lightblue': isRelated(text) }">
        <ncs-context-text :document="result.document" :text="text.text" :elements="text.elements" />
      </li>
    </ul>
    <a class="btn btn-primary btn-sm my-3" v-if="last < this.result.texts.length - 1" @click.prevent="after += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        before: 0,
        after: 0
      }
    },
    computed: {
      ...mapState({
        visible: s => s.api.resultDisplay === 'intervention',
        query: s => s.api.query,
        result: s => s.api.result,
      }),
      searchedText() {
        return this.result.texts.find(this.isSearched)
      },
      sectionIds() {
        return _.compact(_.uniq(this.searchedText.elements.flatMap(e => e.section_id)))
      },
      sectionRefs() {
        return _.compact(_.uniq(this.searchedText.elements.flatMap(e => e.section_ref)))
      },
      first() {
        return Math.max(this.result.texts.findIndex(this.isRelated) - this.before, 0)
      },
      last() {
        return Math.min(this.result.texts.findLastIndex(this.isRelated) + this.after, this.result.texts.length - 1)
      },
      visibleTexts() {
        return this.result.texts.slice(this.first, this.last + 1)
      }
    },
    methods: {
      isSearched(text) {
        return text.text.id === this.query.uncached.text
      },
      isRelated(text) {
        return this.isSearched(text) || text.elements.some(e => {
          const isReferenced = e?.section_id?.some(id => this.sectionRefs.includes(id))
          const references = e?.section_ref?.some(id => this.sectionIds.includes(id))
          return isReferenced || references
        })
      }
    }
  }
</script>
